// Automatically generated with Reach 0.1.8 (dab71275)
/* eslint-disable */
export const _version = '0.1.8';
export const _versionHash = '0.1.8 (dab71275)';
export const _backendVersion = 7;

export function getExports(s) {
  const stdlib = s.reachStdlib;
  return {
    };
  };
export function _getEvents(s) {
  const stdlib = s.reachStdlib;
  return {
    };
  };
export function _getViews(s, viewlib) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Bool;
  
  return {
    infos: {
      Auction: {
        bids: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v534, v535, v536, v537, v541] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v577, v598, v599] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        closed: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v534, v535, v536, v537, v541] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v577, v598, v599] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return true;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return true;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641] = svs;
              return (await ((async () => {
                
                
                return false;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc3
          },
        closes: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v534, v535, v536, v537, v541] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v577, v598, v599] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        currentPrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v534, v535, v536, v537, v541] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v577, v598, v599] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return v610;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return v610;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641] = svs;
              return (await ((async () => {
                
                
                return v610;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        endCTime: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v534, v535, v536, v537, v541] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v577, v598, v599] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        endSecs: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v534, v535, v536, v537, v541] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v577, v598, v599] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return v611;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return v611;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641] = svs;
              return (await ((async () => {
                
                
                return v611;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        highestBidder: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v534, v535, v536, v537, v541] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v577, v598, v599] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return v612;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return v612;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641] = svs;
              return (await ((async () => {
                
                
                return v612;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc0
          },
        lastCTime: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v534, v535, v536, v537, v541] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v577, v598, v599] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        minBid: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v534, v535, v536, v537, v541] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v577, v598, v599] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return v1023;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return v1023;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641] = svs;
              return (await ((async () => {
                
                
                return v641;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        owner: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v534, v535, v536, v537, v541] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v577, v598, v599] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return v565;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return v565;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641] = svs;
              return (await ((async () => {
                
                
                return v565;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc0
          },
        reservePrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v534, v535, v536, v537, v541] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v577, v598, v599] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return v568;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return v568;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641] = svs;
              return (await ((async () => {
                
                
                return v568;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        royalties: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v534, v535, v536, v537, v541] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v577, v598, v599] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return v567;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return v567;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641] = svs;
              return (await ((async () => {
                
                
                return v567;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        startPrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v534, v535, v536, v537, v541] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v577, v598, v599] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return v569;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return v569;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641] = svs;
              return (await ((async () => {
                
                
                return v569;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        token: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v534, v535, v536, v537, v541] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v577, v598, v599] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return v574;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
              const [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023] = svs;
              return (await ((async () => {
                
                
                return v574;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8))) {
              const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641] = svs;
              return (await ((async () => {
                
                
                return v574;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc2
          }
        }
      },
    views: {
      1: [ctc0, ctc0, ctc0, ctc0, ctc0],
      2: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc0],
      4: [ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc0, ctc1],
      6: [ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc0, ctc1],
      8: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1]
      }
    };
  
  };
export function _getMaps(s) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Tuple([]);
  return {
    mapDataTy: ctc0
    };
  };
export async function Auctioneer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Auctioneer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Auctioneer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Object({
    bidIncrementAbs: ctc1,
    bidIncrementRel: ctc1,
    deadline: ctc1,
    deadlineSecs: ctc1,
    deadlineStep: ctc1,
    maxDeadline: ctc1,
    reservePrice: ctc1,
    royaltyAddr: ctc0,
    royaltyCents: ctc1,
    startPrice: ctc1,
    token: ctc2,
    unitAmount: ctc1
    });
  const ctc4 = stdlib.T_Null;
  const ctc5 = stdlib.T_Tuple([ctc4]);
  const ctc6 = stdlib.T_Tuple([ctc1]);
  const ctc7 = stdlib.T_Data({
    Bid_close0_151: ctc5,
    Bid_getBid0_151: ctc6,
    Bid_getPurchase0_151: ctc6,
    Bid_touch0_151: ctc5
    });
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 4,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v534, v535, v536, v537], secs: v539, time: v538, didSend: v36, from: v533 } = txn1;
  ;
  const v541 = v537;
  const v547 = stdlib.protect(ctc3, await interact.getParams(), {
    at: './index.rsh:86:38:application',
    fs: ['at ./index.rsh:71:18:application call to [unknown function] (defined at: ./index.rsh:71:22:function exp)'],
    msg: 'getParams',
    who: 'Auctioneer'
    });
  const v548 = v547.royaltyAddr;
  const v549 = v547.royaltyCents;
  const v550 = v547.token;
  const v551 = v547.reservePrice;
  const v552 = v547.startPrice;
  const v553 = v547.bidIncrementAbs;
  const v554 = v547.bidIncrementRel;
  const v555 = v547.deadline;
  const v556 = v547.maxDeadline;
  const v557 = v547.unitAmount;
  const v558 = v547.deadlineStep;
  const v559 = v547.deadlineSecs;
  const v560 = stdlib.ge(v549, stdlib.checkedBigNumberify('./index.rsh:87:28:decimal', stdlib.UInt_max, 0));
  const v561 = stdlib.le(v549, stdlib.checkedBigNumberify('./index.rsh:87:49:decimal', stdlib.UInt_max, 99));
  const v562 = v560 ? v561 : false;
  stdlib.assert(v562, {
    at: './index.rsh:87:11:application',
    fs: ['at ./index.rsh:71:18:application call to [unknown function] (defined at: ./index.rsh:71:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  const v563 = stdlib.ge(v552, stdlib.checkedBigNumberify('./index.rsh:88:26:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v563, {
    at: './index.rsh:88:11:application',
    fs: ['at ./index.rsh:71:18:application call to [unknown function] (defined at: ./index.rsh:71:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  const v564 = stdlib.lt(v552, v551);
  stdlib.assert(v564, {
    at: './index.rsh:89:11:application',
    fs: ['at ./index.rsh:71:18:application call to [unknown function] (defined at: ./index.rsh:71:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  
  const txn2 = await (ctc.sendrecv({
    args: [v534, v535, v536, v537, v541, v548, v549, v551, v552, v553, v554, v555, v556, v550, v557, v558, v559],
    evt_cnt: 12,
    funcNum: 1,
    lct: v538,
    onlyIf: true,
    out_tys: [ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc1],
    pay: [stdlib.checkedBigNumberify('./index.rsh:107:11:decimal', stdlib.UInt_max, 300000), []],
    sim_p: (async (txn2) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v566, v567, v568, v569, v570, v571, v572, v573, v574, v575, v576, v577], secs: v579, time: v578, didSend: v80, from: v565 } = txn2;
      
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
        kind: 'init',
        tok: v574
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./index.rsh:107:11:decimal', stdlib.UInt_max, 300000),
        kind: 'to',
        tok: undefined
        });
      const v582 = stdlib.ge(v567, stdlib.checkedBigNumberify('./index.rsh:108:27:decimal', stdlib.UInt_max, 0));
      const v583 = stdlib.le(v567, stdlib.checkedBigNumberify('./index.rsh:108:48:decimal', stdlib.UInt_max, 99));
      const v584 = v582 ? v583 : false;
      stdlib.assert(v584, {
        at: './index.rsh:108:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v585 = stdlib.ge(v569, stdlib.checkedBigNumberify('./index.rsh:109:25:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v585, {
        at: './index.rsh:109:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v586 = stdlib.lt(v569, v568);
      stdlib.assert(v586, {
        at: './index.rsh:110:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v590 = stdlib.sub(stdlib.checkedBigNumberify('./index.rsh:107:11:decimal', stdlib.UInt_max, 300000), stdlib.checkedBigNumberify('./index.rsh:112:12:decimal', stdlib.UInt_max, 100000));
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./index.rsh:112:12:decimal', stdlib.UInt_max, 100000),
        kind: 'from',
        to: v534,
        tok: undefined
        });
      const v594 = stdlib.sub(v590, stdlib.checkedBigNumberify('./index.rsh:113:12:decimal', stdlib.UInt_max, 100000));
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./index.rsh:113:12:decimal', stdlib.UInt_max, 100000),
        kind: 'from',
        to: v536,
        tok: undefined
        });
      const v598 = stdlib.sub(v594, stdlib.checkedBigNumberify('./index.rsh:114:12:decimal', stdlib.UInt_max, 100000));
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./index.rsh:114:12:decimal', stdlib.UInt_max, 100000),
        kind: 'from',
        to: v537,
        tok: undefined
        });
      const v599 = v565;
      sim_r.isHalt = false;
      
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc1],
    waitIfNotPresent: false
    }));
  const {data: [v566, v567, v568, v569, v570, v571, v572, v573, v574, v575, v576, v577], secs: v579, time: v578, didSend: v80, from: v565 } = txn2;
  ;
  ;
  const v582 = stdlib.ge(v567, stdlib.checkedBigNumberify('./index.rsh:108:27:decimal', stdlib.UInt_max, 0));
  const v583 = stdlib.le(v567, stdlib.checkedBigNumberify('./index.rsh:108:48:decimal', stdlib.UInt_max, 99));
  const v584 = v582 ? v583 : false;
  stdlib.assert(v584, {
    at: './index.rsh:108:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v585 = stdlib.ge(v569, stdlib.checkedBigNumberify('./index.rsh:109:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v585, {
    at: './index.rsh:109:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v586 = stdlib.lt(v569, v568);
  stdlib.assert(v586, {
    at: './index.rsh:110:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v590 = stdlib.sub(stdlib.checkedBigNumberify('./index.rsh:107:11:decimal', stdlib.UInt_max, 300000), stdlib.checkedBigNumberify('./index.rsh:112:12:decimal', stdlib.UInt_max, 100000));
  ;
  const v594 = stdlib.sub(v590, stdlib.checkedBigNumberify('./index.rsh:113:12:decimal', stdlib.UInt_max, 100000));
  ;
  const v598 = stdlib.sub(v594, stdlib.checkedBigNumberify('./index.rsh:114:12:decimal', stdlib.UInt_max, 100000));
  ;
  const v599 = v565;
  const txn3 = await (ctc.recv({
    didSend: false,
    evt_cnt: 0,
    funcNum: 2,
    out_tys: [],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [], secs: v602, time: v601, didSend: v106, from: v600 } = txn3;
  ;
  ;
  const v606 = stdlib.addressEq(v599, v600);
  stdlib.assert(v606, {
    at: './index.rsh:120:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Auctioneer'
    });
  const v609 = 'Start Auction';
  stdlib.protect(ctc4, await interact.log(v609), {
    at: './index.rsh:125:40:application',
    fs: ['at ./index.rsh:125:7:application call to [unknown function] (defined at: ./index.rsh:125:25:function exp)'],
    msg: 'log',
    who: 'Auctioneer'
    });
  
  let v610 = stdlib.checkedBigNumberify('./index.rsh:155:24:decimal', stdlib.UInt_max, 0);
  let v611 = v577;
  let v612 = v565;
  let v613 = true;
  let v614 = v601;
  let v617 = v602;
  let v620 = v598;
  let v621 = stdlib.checkedBigNumberify('./index.rsh:120:12:decimal', stdlib.UInt_max, 1);
  
  while (await (async () => {
    
    return v613;})()) {
    const v636 = stdlib.add(v610, v570);
    const v637 = stdlib.div(v610, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
    const v638 = stdlib.mul(v637, v571);
    const v639 = stdlib.add(v610, v638);
    const v640 = stdlib.gt(v636, v639);
    const v641 = v640 ? v636 : v639;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc7],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v699], secs: v701, time: v700, didSend: v385, from: v698 } = txn4;
    switch (v699[0]) {
      case 'Bid_close0_151': {
        const v702 = v699[1];
        ;
        undefined;
        const v718 = null;
        await txn4.getOutput('Bid_close', 'v718', ctc4, v718);
        const v725 = stdlib.lt(v617, v611);
        const cv610 = v610;
        const cv611 = v611;
        const cv612 = v612;
        const cv613 = v725;
        const cv614 = v700;
        const cv617 = v701;
        const cv620 = v620;
        const cv621 = v621;
        
        v610 = cv610;
        v611 = cv611;
        v612 = cv612;
        v613 = cv613;
        v614 = cv614;
        v617 = cv617;
        v620 = cv620;
        v621 = cv621;
        
        continue;
        break;
        }
      case 'Bid_getBid0_151': {
        const v781 = v699[1];
        const v788 = v781[stdlib.checkedBigNumberify('./index.rsh:186:11:spread', stdlib.UInt_max, 0)];
        const v794 = stdlib.add(v620, v788);
        ;
        undefined;
        const v809 = stdlib.lt(v617, v611);
        const v816 = stdlib.ge(v788, v641);
        const v817 = v809 ? v816 : false;
        const v818 = stdlib.ge(v788, v569);
        const v819 = v817 ? v818 : false;
        stdlib.assert(v819, {
          at: './index.rsh:193:18:application',
          fs: ['at ./index.rsh:192:9:application call to [unknown function] (defined at: ./index.rsh:192:9:function exp)'],
          msg: null,
          who: 'Auctioneer'
          });
        const v823 = stdlib.sub(v794, v610);
        ;
        const v824 = null;
        await txn4.getOutput('Bid_getBid', 'v824', ctc4, v824);
        const v830 = stdlib.add(v611, stdlib.checkedBigNumberify('./index.rsh:143:33:decimal', stdlib.UInt_max, 60));
        const cv610 = v788;
        const cv611 = v830;
        const cv612 = v698;
        const cv613 = true;
        const cv614 = v700;
        const cv617 = v701;
        const cv620 = v823;
        const cv621 = v621;
        
        v610 = cv610;
        v611 = cv611;
        v612 = cv612;
        v613 = cv613;
        v614 = cv614;
        v617 = cv617;
        v620 = cv620;
        v621 = cv621;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0_151': {
        const v860 = v699[1];
        const v869 = v860[stdlib.checkedBigNumberify('./index.rsh:211:11:spread', stdlib.UInt_max, 0)];
        const v873 = stdlib.add(v620, v869);
        ;
        undefined;
        const v914 = stdlib.ge(v617, v611);
        const v915 = stdlib.lt(v610, v568);
        const v916 = v914 ? v915 : false;
        const v917 = stdlib.ge(v869, v568);
        const v918 = v916 ? v917 : false;
        stdlib.assert(v918, {
          at: './index.rsh:219:18:application',
          fs: ['at ./index.rsh:218:9:application call to [unknown function] (defined at: ./index.rsh:218:9:function exp)'],
          msg: null,
          who: 'Auctioneer'
          });
        const v922 = stdlib.sub(v873, v610);
        ;
        const v923 = null;
        await txn4.getOutput('Bid_getPurchase', 'v923', ctc4, v923);
        const cv610 = v869;
        const cv611 = v611;
        const cv612 = v698;
        const cv613 = false;
        const cv614 = v700;
        const cv617 = v701;
        const cv620 = v922;
        const cv621 = v621;
        
        v610 = cv610;
        v611 = cv611;
        v612 = cv612;
        v613 = cv613;
        v614 = cv614;
        v617 = cv617;
        v620 = cv620;
        v621 = cv621;
        
        continue;
        break;
        }
      case 'Bid_touch0_151': {
        const v939 = v699[1];
        ;
        undefined;
        const v1011 = null;
        await txn4.getOutput('Bid_touch', 'v1011', ctc4, v1011);
        const cv610 = v610;
        const cv611 = v611;
        const cv612 = v612;
        const cv613 = true;
        const cv614 = v700;
        const cv617 = v701;
        const cv620 = v620;
        const cv621 = v621;
        
        v610 = cv610;
        v611 = cv611;
        v612 = cv612;
        v613 = cv613;
        v614 = cv614;
        v617 = cv617;
        v620 = cv620;
        v621 = cv621;
        
        continue;
        break;
        }
      }
    
    }
  const v1018 = stdlib.add(v610, v570);
  const v1019 = stdlib.div(v610, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
  const v1020 = stdlib.mul(v1019, v571);
  const v1021 = stdlib.add(v610, v1020);
  const v1022 = stdlib.gt(v1018, v1021);
  const v1023 = v1022 ? v1018 : v1021;
  const v1025 = stdlib.div(v620, stdlib.checkedBigNumberify('./index.rsh:257:28:decimal', stdlib.UInt_max, 100));
  const v1026 = stdlib.mul(v567, v1025);
  const v1028 = stdlib.add(v1026, v1025);
  const v1029 = stdlib.sub(v620, v1028);
  const v1030 = stdlib.ge(v610, v568);
  if (v1030) {
    ;
    ;
    ;
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 4,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1051, time: v1050, didSend: v511, from: v1049 } = txn4;
    ;
    const v1053 = stdlib.addressEq(v541, v1049);
    stdlib.assert(v1053, {
      at: './index.rsh:295:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Auctioneer'
      });
    return;
    
    
    }
  else {
    const v1058 = stdlib.add(v1029, v1026);
    const v1059 = stdlib.add(v1058, v1025);
    ;
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 5,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1072, time: v1071, didSend: v511, from: v1070 } = txn4;
    ;
    const v1074 = stdlib.addressEq(v541, v1070);
    stdlib.assert(v1074, {
      at: './index.rsh:295:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Auctioneer'
      });
    return;
    
    
    }
  
  
  
  
  
  };
export async function Bid_close(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_close expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_close expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_close0_151: ctc4,
    Bid_getBid0_151: ctc5,
    Bid_getPurchase0_151: ctc5,
    Bid_touch0_151: ctc4
    });
  
  
  const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8), [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1]);
  const v684 = stdlib.protect(ctc4, await interact.in(), {
    at: './index.rsh:1:23:application',
    fs: ['at ./index.rsh:236:11:application call to [unknown function] (defined at: ./index.rsh:236:11:function exp)', 'at ./index.rsh:152:19:application call to "runBid_close0_151" (defined at: ./index.rsh:236:11:function exp)', 'at ./index.rsh:152:19:application call to [unknown function] (defined at: ./index.rsh:152:19:function exp)'],
    msg: 'in',
    who: 'Bid_close'
    });
  
  const v690 = ['Bid_close0_151', v684];
  
  const txn1 = await (ctc.sendrecv({
    args: [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641, v690],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./index.rsh:237:17:decimal', stdlib.UInt_max, 0), []],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v699], secs: v701, time: v700, didSend: v385, from: v698 } = txn1;
      
      switch (v699[0]) {
        case 'Bid_close0_151': {
          const v702 = v699[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./index.rsh:237:17:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          undefined;
          const v718 = null;
          const v719 = await txn1.getOutput('Bid_close', 'v718', ctc3, v718);
          
          const v725 = stdlib.lt(v617, v611);
          const v1981 = v610;
          const v1982 = v611;
          const v1983 = v612;
          const v1986 = v701;
          const v1987 = v620;
          const v1988 = v621;
          if (v725) {
            const v1989 = stdlib.add(v610, v570);
            const v1990 = stdlib.div(v610, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
            const v1991 = stdlib.mul(v1990, v571);
            const v1992 = stdlib.add(v610, v1991);
            const v1993 = stdlib.gt(v1989, v1992);
            const v1994 = v1993 ? v1989 : v1992;
            sim_r.isHalt = false;
            }
          else {
            const v1995 = stdlib.add(v610, v570);
            const v1996 = stdlib.div(v610, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
            const v1997 = stdlib.mul(v1996, v571);
            const v1998 = stdlib.add(v610, v1997);
            const v1999 = stdlib.gt(v1995, v1998);
            const v2000 = v1999 ? v1995 : v1998;
            const v2001 = stdlib.div(v620, stdlib.checkedBigNumberify('./index.rsh:257:28:decimal', stdlib.UInt_max, 100));
            const v2002 = stdlib.mul(v567, v2001);
            const v2003 = stdlib.add(v2002, v2001);
            const v2004 = stdlib.sub(v620, v2003);
            const v2005 = stdlib.ge(v610, v568);
            if (v2005) {
              sim_r.txns.push({
                amt: v621,
                kind: 'from',
                to: v612,
                tok: v574
                });
              sim_r.txns.push({
                amt: v2002,
                kind: 'from',
                to: v566,
                tok: undefined
                });
              sim_r.txns.push({
                amt: v2001,
                kind: 'from',
                to: v535,
                tok: undefined
                });
              sim_r.txns.push({
                amt: v2004,
                kind: 'from',
                to: v565,
                tok: undefined
                });
              sim_r.isHalt = false;
              }
            else {
              const v2011 = stdlib.add(v2004, v2002);
              const v2012 = stdlib.add(v2011, v2001);
              sim_r.txns.push({
                amt: v2012,
                kind: 'from',
                to: v612,
                tok: undefined
                });
              sim_r.txns.push({
                amt: v621,
                kind: 'from',
                to: v565,
                tok: v574
                });
              sim_r.isHalt = false;
              }}
          break;
          }
        case 'Bid_getBid0_151': {
          const v781 = v699[1];
          
          break;
          }
        case 'Bid_getPurchase0_151': {
          const v860 = v699[1];
          
          break;
          }
        case 'Bid_touch0_151': {
          const v939 = v699[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v699], secs: v701, time: v700, didSend: v385, from: v698 } = txn1;
  switch (v699[0]) {
    case 'Bid_close0_151': {
      const v702 = v699[1];
      ;
      undefined;
      const v718 = null;
      const v719 = await txn1.getOutput('Bid_close', 'v718', ctc3, v718);
      if (v385) {
        stdlib.protect(ctc3, await interact.out(v702, v719), {
          at: './index.rsh:236:12:application',
          fs: ['at ./index.rsh:236:12:application call to [unknown function] (defined at: ./index.rsh:236:12:function exp)', 'at ./index.rsh:239:12:application call to "k" (defined at: ./index.rsh:238:9:function exp)', 'at ./index.rsh:238:9:application call to [unknown function] (defined at: ./index.rsh:238:9:function exp)'],
          msg: 'out',
          who: 'Bid_close'
          });
        }
      else {
        }
      
      const v725 = stdlib.lt(v617, v611);
      const v1981 = v610;
      const v1982 = v611;
      const v1983 = v612;
      const v1986 = v701;
      const v1987 = v620;
      const v1988 = v621;
      if (v725) {
        const v1989 = stdlib.add(v610, v570);
        const v1990 = stdlib.div(v610, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
        const v1991 = stdlib.mul(v1990, v571);
        const v1992 = stdlib.add(v610, v1991);
        const v1993 = stdlib.gt(v1989, v1992);
        const v1994 = v1993 ? v1989 : v1992;
        return;
        }
      else {
        const v1995 = stdlib.add(v610, v570);
        const v1996 = stdlib.div(v610, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
        const v1997 = stdlib.mul(v1996, v571);
        const v1998 = stdlib.add(v610, v1997);
        const v1999 = stdlib.gt(v1995, v1998);
        const v2000 = v1999 ? v1995 : v1998;
        const v2001 = stdlib.div(v620, stdlib.checkedBigNumberify('./index.rsh:257:28:decimal', stdlib.UInt_max, 100));
        const v2002 = stdlib.mul(v567, v2001);
        const v2003 = stdlib.add(v2002, v2001);
        const v2004 = stdlib.sub(v620, v2003);
        const v2005 = stdlib.ge(v610, v568);
        if (v2005) {
          ;
          ;
          ;
          ;
          return;
          }
        else {
          const v2011 = stdlib.add(v2004, v2002);
          const v2012 = stdlib.add(v2011, v2001);
          ;
          ;
          return;
          }}
      break;
      }
    case 'Bid_getBid0_151': {
      const v781 = v699[1];
      return;
      break;
      }
    case 'Bid_getPurchase0_151': {
      const v860 = v699[1];
      return;
      break;
      }
    case 'Bid_touch0_151': {
      const v939 = v699[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_getBid(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_getBid expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_getBid expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Tuple([ctc1]);
  const ctc4 = stdlib.T_Null;
  const ctc5 = stdlib.T_Tuple([ctc4]);
  const ctc6 = stdlib.T_Data({
    Bid_close0_151: ctc5,
    Bid_getBid0_151: ctc3,
    Bid_getPurchase0_151: ctc3,
    Bid_touch0_151: ctc5
    });
  
  
  const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8), [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1]);
  const v652 = stdlib.protect(ctc3, await interact.in(), {
    at: './index.rsh:1:23:application',
    fs: ['at ./index.rsh:187:9:application call to [unknown function] (defined at: ./index.rsh:187:9:function exp)', 'at ./index.rsh:152:19:application call to "runBid_getBid0_151" (defined at: ./index.rsh:186:11:function exp)', 'at ./index.rsh:152:19:application call to [unknown function] (defined at: ./index.rsh:152:19:function exp)'],
    msg: 'in',
    who: 'Bid_getBid'
    });
  const v653 = v652[stdlib.checkedBigNumberify('./index.rsh:186:11:spread', stdlib.UInt_max, 0)];
  const v655 = stdlib.lt(v617, v611);
  const v662 = stdlib.ge(v653, v641);
  const v663 = v655 ? v662 : false;
  const v664 = stdlib.ge(v653, v569);
  const v665 = v663 ? v664 : false;
  stdlib.assert(v665, {
    at: './index.rsh:187:25:application',
    fs: ['at ./index.rsh:187:9:application call to [unknown function] (defined at: ./index.rsh:187:16:function exp)', 'at ./index.rsh:187:9:application call to [unknown function] (defined at: ./index.rsh:187:9:function exp)', 'at ./index.rsh:152:19:application call to "runBid_getBid0_151" (defined at: ./index.rsh:186:11:function exp)', 'at ./index.rsh:152:19:application call to [unknown function] (defined at: ./index.rsh:152:19:function exp)'],
    msg: null,
    who: 'Bid_getBid'
    });
  
  const v692 = ['Bid_getBid0_151', v652];
  
  const txn1 = await (ctc.sendrecv({
    args: [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641, v692],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [v653, []],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v699], secs: v701, time: v700, didSend: v385, from: v698 } = txn1;
      
      switch (v699[0]) {
        case 'Bid_close0_151': {
          const v702 = v699[1];
          
          break;
          }
        case 'Bid_getBid0_151': {
          const v781 = v699[1];
          const v788 = v781[stdlib.checkedBigNumberify('./index.rsh:186:11:spread', stdlib.UInt_max, 0)];
          const v794 = stdlib.add(v620, v788);
          sim_r.txns.push({
            amt: v788,
            kind: 'to',
            tok: undefined
            });
          undefined;
          const v816 = stdlib.ge(v788, v641);
          const v817 = v655 ? v816 : false;
          const v818 = stdlib.ge(v788, v569);
          const v819 = v817 ? v818 : false;
          stdlib.assert(v819, {
            at: './index.rsh:193:18:application',
            fs: ['at ./index.rsh:192:9:application call to [unknown function] (defined at: ./index.rsh:192:9:function exp)'],
            msg: null,
            who: 'Bid_getBid'
            });
          const v823 = stdlib.sub(v794, v610);
          sim_r.txns.push({
            amt: v610,
            kind: 'from',
            to: v612,
            tok: undefined
            });
          const v824 = null;
          const v825 = await txn1.getOutput('Bid_getBid', 'v824', ctc4, v824);
          
          const v830 = stdlib.add(v611, stdlib.checkedBigNumberify('./index.rsh:143:33:decimal', stdlib.UInt_max, 60));
          const v2166 = v788;
          const v2167 = v830;
          const v2168 = v698;
          const v2171 = v701;
          const v2172 = v823;
          const v2173 = v621;
          const v2174 = stdlib.add(v788, v570);
          const v2175 = stdlib.div(v788, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
          const v2176 = stdlib.mul(v2175, v571);
          const v2177 = stdlib.add(v788, v2176);
          const v2178 = stdlib.gt(v2174, v2177);
          const v2179 = v2178 ? v2174 : v2177;
          sim_r.isHalt = false;
          
          break;
          }
        case 'Bid_getPurchase0_151': {
          const v860 = v699[1];
          
          break;
          }
        case 'Bid_touch0_151': {
          const v939 = v699[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v699], secs: v701, time: v700, didSend: v385, from: v698 } = txn1;
  switch (v699[0]) {
    case 'Bid_close0_151': {
      const v702 = v699[1];
      return;
      break;
      }
    case 'Bid_getBid0_151': {
      const v781 = v699[1];
      const v788 = v781[stdlib.checkedBigNumberify('./index.rsh:186:11:spread', stdlib.UInt_max, 0)];
      const v794 = stdlib.add(v620, v788);
      ;
      undefined;
      const v816 = stdlib.ge(v788, v641);
      const v817 = v655 ? v816 : false;
      const v818 = stdlib.ge(v788, v569);
      const v819 = v817 ? v818 : false;
      stdlib.assert(v819, {
        at: './index.rsh:193:18:application',
        fs: ['at ./index.rsh:192:9:application call to [unknown function] (defined at: ./index.rsh:192:9:function exp)'],
        msg: null,
        who: 'Bid_getBid'
        });
      const v823 = stdlib.sub(v794, v610);
      ;
      const v824 = null;
      const v825 = await txn1.getOutput('Bid_getBid', 'v824', ctc4, v824);
      if (v385) {
        stdlib.protect(ctc4, await interact.out(v781, v825), {
          at: './index.rsh:186:12:application',
          fs: ['at ./index.rsh:186:12:application call to [unknown function] (defined at: ./index.rsh:186:12:function exp)', 'at ./index.rsh:198:12:application call to "k" (defined at: ./index.rsh:192:9:function exp)', 'at ./index.rsh:192:9:application call to [unknown function] (defined at: ./index.rsh:192:9:function exp)'],
          msg: 'out',
          who: 'Bid_getBid'
          });
        }
      else {
        }
      
      const v830 = stdlib.add(v611, stdlib.checkedBigNumberify('./index.rsh:143:33:decimal', stdlib.UInt_max, 60));
      const v2166 = v788;
      const v2167 = v830;
      const v2168 = v698;
      const v2171 = v701;
      const v2172 = v823;
      const v2173 = v621;
      const v2174 = stdlib.add(v788, v570);
      const v2175 = stdlib.div(v788, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
      const v2176 = stdlib.mul(v2175, v571);
      const v2177 = stdlib.add(v788, v2176);
      const v2178 = stdlib.gt(v2174, v2177);
      const v2179 = v2178 ? v2174 : v2177;
      return;
      
      break;
      }
    case 'Bid_getPurchase0_151': {
      const v860 = v699[1];
      return;
      break;
      }
    case 'Bid_touch0_151': {
      const v939 = v699[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_getPurchase(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_getPurchase expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_getPurchase expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Tuple([ctc1]);
  const ctc4 = stdlib.T_Null;
  const ctc5 = stdlib.T_Tuple([ctc4]);
  const ctc6 = stdlib.T_Data({
    Bid_close0_151: ctc5,
    Bid_getBid0_151: ctc3,
    Bid_getPurchase0_151: ctc3,
    Bid_touch0_151: ctc5
    });
  
  
  const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8), [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1]);
  const v671 = stdlib.protect(ctc3, await interact.in(), {
    at: './index.rsh:1:23:application',
    fs: ['at ./index.rsh:212:9:application call to [unknown function] (defined at: ./index.rsh:212:9:function exp)', 'at ./index.rsh:152:19:application call to "runBid_getPurchase0_151" (defined at: ./index.rsh:211:11:function exp)', 'at ./index.rsh:152:19:application call to [unknown function] (defined at: ./index.rsh:152:19:function exp)'],
    msg: 'in',
    who: 'Bid_getPurchase'
    });
  const v672 = v671[stdlib.checkedBigNumberify('./index.rsh:211:11:spread', stdlib.UInt_max, 0)];
  const v674 = stdlib.ge(v617, v611);
  const v675 = stdlib.lt(v610, v568);
  const v676 = v674 ? v675 : false;
  const v677 = stdlib.ge(v672, v568);
  const v678 = v676 ? v677 : false;
  stdlib.assert(v678, {
    at: './index.rsh:212:25:application',
    fs: ['at ./index.rsh:212:9:application call to [unknown function] (defined at: ./index.rsh:212:16:function exp)', 'at ./index.rsh:212:9:application call to [unknown function] (defined at: ./index.rsh:212:9:function exp)', 'at ./index.rsh:152:19:application call to "runBid_getPurchase0_151" (defined at: ./index.rsh:211:11:function exp)', 'at ./index.rsh:152:19:application call to [unknown function] (defined at: ./index.rsh:152:19:function exp)'],
    msg: null,
    who: 'Bid_getPurchase'
    });
  
  const v694 = ['Bid_getPurchase0_151', v671];
  
  const txn1 = await (ctc.sendrecv({
    args: [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641, v694],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [v672, []],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v699], secs: v701, time: v700, didSend: v385, from: v698 } = txn1;
      
      switch (v699[0]) {
        case 'Bid_close0_151': {
          const v702 = v699[1];
          
          break;
          }
        case 'Bid_getBid0_151': {
          const v781 = v699[1];
          
          break;
          }
        case 'Bid_getPurchase0_151': {
          const v860 = v699[1];
          const v869 = v860[stdlib.checkedBigNumberify('./index.rsh:211:11:spread', stdlib.UInt_max, 0)];
          const v873 = stdlib.add(v620, v869);
          sim_r.txns.push({
            amt: v869,
            kind: 'to',
            tok: undefined
            });
          undefined;
          const v917 = stdlib.ge(v869, v568);
          const v918 = v676 ? v917 : false;
          stdlib.assert(v918, {
            at: './index.rsh:219:18:application',
            fs: ['at ./index.rsh:218:9:application call to [unknown function] (defined at: ./index.rsh:218:9:function exp)'],
            msg: null,
            who: 'Bid_getPurchase'
            });
          const v922 = stdlib.sub(v873, v610);
          sim_r.txns.push({
            amt: v610,
            kind: 'from',
            to: v612,
            tok: undefined
            });
          const v923 = null;
          const v924 = await txn1.getOutput('Bid_getPurchase', 'v923', ctc4, v923);
          
          const v2351 = v869;
          const v2352 = v611;
          const v2353 = v698;
          const v2365 = stdlib.add(v869, v570);
          const v2366 = stdlib.div(v869, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
          const v2367 = stdlib.mul(v2366, v571);
          const v2368 = stdlib.add(v869, v2367);
          const v2369 = stdlib.gt(v2365, v2368);
          const v2370 = v2369 ? v2365 : v2368;
          const v2371 = stdlib.div(v922, stdlib.checkedBigNumberify('./index.rsh:257:28:decimal', stdlib.UInt_max, 100));
          const v2372 = stdlib.mul(v567, v2371);
          const v2373 = stdlib.add(v2372, v2371);
          const v2374 = stdlib.sub(v922, v2373);
          if (v917) {
            sim_r.txns.push({
              amt: v621,
              kind: 'from',
              to: v698,
              tok: v574
              });
            sim_r.txns.push({
              amt: v2372,
              kind: 'from',
              to: v566,
              tok: undefined
              });
            sim_r.txns.push({
              amt: v2371,
              kind: 'from',
              to: v535,
              tok: undefined
              });
            sim_r.txns.push({
              amt: v2374,
              kind: 'from',
              to: v565,
              tok: undefined
              });
            sim_r.isHalt = false;
            }
          else {
            const v2381 = stdlib.add(v2374, v2372);
            const v2382 = stdlib.add(v2381, v2371);
            sim_r.txns.push({
              amt: v2382,
              kind: 'from',
              to: v698,
              tok: undefined
              });
            sim_r.txns.push({
              amt: v621,
              kind: 'from',
              to: v565,
              tok: v574
              });
            sim_r.isHalt = false;
            }
          break;
          }
        case 'Bid_touch0_151': {
          const v939 = v699[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v699], secs: v701, time: v700, didSend: v385, from: v698 } = txn1;
  switch (v699[0]) {
    case 'Bid_close0_151': {
      const v702 = v699[1];
      return;
      break;
      }
    case 'Bid_getBid0_151': {
      const v781 = v699[1];
      return;
      break;
      }
    case 'Bid_getPurchase0_151': {
      const v860 = v699[1];
      const v869 = v860[stdlib.checkedBigNumberify('./index.rsh:211:11:spread', stdlib.UInt_max, 0)];
      const v873 = stdlib.add(v620, v869);
      ;
      undefined;
      const v917 = stdlib.ge(v869, v568);
      const v918 = v676 ? v917 : false;
      stdlib.assert(v918, {
        at: './index.rsh:219:18:application',
        fs: ['at ./index.rsh:218:9:application call to [unknown function] (defined at: ./index.rsh:218:9:function exp)'],
        msg: null,
        who: 'Bid_getPurchase'
        });
      const v922 = stdlib.sub(v873, v610);
      ;
      const v923 = null;
      const v924 = await txn1.getOutput('Bid_getPurchase', 'v923', ctc4, v923);
      if (v385) {
        stdlib.protect(ctc4, await interact.out(v860, v924), {
          at: './index.rsh:211:12:application',
          fs: ['at ./index.rsh:211:12:application call to [unknown function] (defined at: ./index.rsh:211:12:function exp)', 'at ./index.rsh:225:12:application call to "k" (defined at: ./index.rsh:218:9:function exp)', 'at ./index.rsh:218:9:application call to [unknown function] (defined at: ./index.rsh:218:9:function exp)'],
          msg: 'out',
          who: 'Bid_getPurchase'
          });
        }
      else {
        }
      
      const v2351 = v869;
      const v2352 = v611;
      const v2353 = v698;
      const v2365 = stdlib.add(v869, v570);
      const v2366 = stdlib.div(v869, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
      const v2367 = stdlib.mul(v2366, v571);
      const v2368 = stdlib.add(v869, v2367);
      const v2369 = stdlib.gt(v2365, v2368);
      const v2370 = v2369 ? v2365 : v2368;
      const v2371 = stdlib.div(v922, stdlib.checkedBigNumberify('./index.rsh:257:28:decimal', stdlib.UInt_max, 100));
      const v2372 = stdlib.mul(v567, v2371);
      const v2373 = stdlib.add(v2372, v2371);
      const v2374 = stdlib.sub(v922, v2373);
      if (v917) {
        ;
        ;
        ;
        ;
        return;
        }
      else {
        const v2381 = stdlib.add(v2374, v2372);
        const v2382 = stdlib.add(v2381, v2371);
        ;
        ;
        return;
        }
      break;
      }
    case 'Bid_touch0_151': {
      const v939 = v699[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_touch(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_touch expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_touch expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_close0_151: ctc4,
    Bid_getBid0_151: ctc5,
    Bid_getPurchase0_151: ctc5,
    Bid_touch0_151: ctc4
    });
  
  
  const [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8), [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1]);
  const v644 = stdlib.protect(ctc4, await interact.in(), {
    at: './index.rsh:1:23:application',
    fs: ['at ./index.rsh:170:11:application call to [unknown function] (defined at: ./index.rsh:170:11:function exp)', 'at ./index.rsh:152:19:application call to "runBid_touch0_151" (defined at: ./index.rsh:170:11:function exp)', 'at ./index.rsh:152:19:application call to [unknown function] (defined at: ./index.rsh:152:19:function exp)'],
    msg: 'in',
    who: 'Bid_touch'
    });
  
  const v696 = ['Bid_touch0_151', v644];
  
  const txn1 = await (ctc.sendrecv({
    args: [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v610, v611, v612, v617, v620, v621, v641, v696],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./index.rsh:171:17:decimal', stdlib.UInt_max, 0), []],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v699], secs: v701, time: v700, didSend: v385, from: v698 } = txn1;
      
      switch (v699[0]) {
        case 'Bid_close0_151': {
          const v702 = v699[1];
          
          break;
          }
        case 'Bid_getBid0_151': {
          const v781 = v699[1];
          
          break;
          }
        case 'Bid_getPurchase0_151': {
          const v860 = v699[1];
          
          break;
          }
        case 'Bid_touch0_151': {
          const v939 = v699[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./index.rsh:171:17:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          undefined;
          const v1011 = null;
          const v1012 = await txn1.getOutput('Bid_touch', 'v1011', ctc3, v1011);
          
          const v2536 = v610;
          const v2537 = v611;
          const v2538 = v612;
          const v2541 = v701;
          const v2542 = v620;
          const v2543 = v621;
          const v2544 = stdlib.add(v610, v570);
          const v2545 = stdlib.div(v610, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
          const v2546 = stdlib.mul(v2545, v571);
          const v2547 = stdlib.add(v610, v2546);
          const v2548 = stdlib.gt(v2544, v2547);
          const v2549 = v2548 ? v2544 : v2547;
          sim_r.isHalt = false;
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v699], secs: v701, time: v700, didSend: v385, from: v698 } = txn1;
  switch (v699[0]) {
    case 'Bid_close0_151': {
      const v702 = v699[1];
      return;
      break;
      }
    case 'Bid_getBid0_151': {
      const v781 = v699[1];
      return;
      break;
      }
    case 'Bid_getPurchase0_151': {
      const v860 = v699[1];
      return;
      break;
      }
    case 'Bid_touch0_151': {
      const v939 = v699[1];
      ;
      undefined;
      const v1011 = null;
      const v1012 = await txn1.getOutput('Bid_touch', 'v1011', ctc3, v1011);
      if (v385) {
        stdlib.protect(ctc3, await interact.out(v939, v1012), {
          at: './index.rsh:170:12:application',
          fs: ['at ./index.rsh:170:12:application call to [unknown function] (defined at: ./index.rsh:170:12:function exp)', 'at ./index.rsh:173:12:application call to "k" (defined at: ./index.rsh:172:9:function exp)', 'at ./index.rsh:172:9:application call to [unknown function] (defined at: ./index.rsh:172:9:function exp)'],
          msg: 'out',
          who: 'Bid_touch'
          });
        }
      else {
        }
      
      const v2536 = v610;
      const v2537 = v611;
      const v2538 = v612;
      const v2541 = v701;
      const v2542 = v620;
      const v2543 = v621;
      const v2544 = stdlib.add(v610, v570);
      const v2545 = stdlib.div(v610, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
      const v2546 = stdlib.mul(v2545, v571);
      const v2547 = stdlib.add(v610, v2546);
      const v2548 = stdlib.gt(v2544, v2547);
      const v2549 = v2548 ? v2544 : v2547;
      return;
      
      break;
      }
    }
  
  
  };
export async function Constructor(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Constructor expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Constructor expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_Object({
    addr: ctc0,
    addr2: ctc0,
    addr3: ctc0,
    addr4: ctc0
    });
  const ctc2 = stdlib.T_Null;
  const ctc3 = stdlib.T_UInt;
  const ctc4 = stdlib.T_Token;
  const ctc5 = stdlib.T_Tuple([ctc2]);
  const ctc6 = stdlib.T_Tuple([ctc3]);
  const ctc7 = stdlib.T_Data({
    Bid_close0_151: ctc5,
    Bid_getBid0_151: ctc6,
    Bid_getPurchase0_151: ctc6,
    Bid_touch0_151: ctc5
    });
  
  
  const v528 = stdlib.protect(ctc1, await interact.getParams(), {
    at: './util.rsh:43:38:application',
    fs: ['at ./util.rsh:37:19:application call to [unknown function] (defined at: ./util.rsh:37:23:function exp)', 'at ./index.rsh:66:50:application call to "construct" (defined at: ./util.rsh:36:47:function exp)'],
    msg: 'getParams',
    who: 'Constructor'
    });
  const v529 = v528.addr;
  const v530 = v528.addr2;
  const v531 = v528.addr3;
  const v532 = v528.addr4;
  
  const txn1 = await (ctc.sendrecv({
    args: [v529, v530, v531, v532],
    evt_cnt: 4,
    funcNum: 0,
    lct: stdlib.checkedBigNumberify('./util.rsh:47:6:dot', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    pay: [stdlib.checkedBigNumberify('./util.rsh:47:6:decimal', stdlib.UInt_max, 0), []],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v534, v535, v536, v537], secs: v539, time: v538, didSend: v36, from: v533 } = txn1;
      
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./util.rsh:47:6:decimal', stdlib.UInt_max, 0),
        kind: 'to',
        tok: undefined
        });
      const v541 = v537;
      sim_r.isHalt = false;
      
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0],
    waitIfNotPresent: false
    }));
  const {data: [v534, v535, v536, v537], secs: v539, time: v538, didSend: v36, from: v533 } = txn1;
  ;
  const v541 = v537;
  stdlib.protect(ctc2, await interact.signal(), {
    at: './util.rsh:55:41:application',
    fs: ['at ./util.rsh:55:19:application call to [unknown function] (defined at: ./util.rsh:55:23:function exp)', 'at ./index.rsh:66:50:application call to "construct" (defined at: ./util.rsh:36:47:function exp)'],
    msg: 'signal',
    who: 'Constructor'
    });
  
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 12,
    funcNum: 1,
    out_tys: [ctc0, ctc3, ctc3, ctc3, ctc3, ctc3, ctc3, ctc3, ctc4, ctc3, ctc3, ctc3],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v566, v567, v568, v569, v570, v571, v572, v573, v574, v575, v576, v577], secs: v579, time: v578, didSend: v80, from: v565 } = txn2;
  ;
  ;
  const v582 = stdlib.ge(v567, stdlib.checkedBigNumberify('./index.rsh:108:27:decimal', stdlib.UInt_max, 0));
  const v583 = stdlib.le(v567, stdlib.checkedBigNumberify('./index.rsh:108:48:decimal', stdlib.UInt_max, 99));
  const v584 = v582 ? v583 : false;
  stdlib.assert(v584, {
    at: './index.rsh:108:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v585 = stdlib.ge(v569, stdlib.checkedBigNumberify('./index.rsh:109:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v585, {
    at: './index.rsh:109:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v586 = stdlib.lt(v569, v568);
  stdlib.assert(v586, {
    at: './index.rsh:110:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v590 = stdlib.sub(stdlib.checkedBigNumberify('./index.rsh:107:11:decimal', stdlib.UInt_max, 300000), stdlib.checkedBigNumberify('./index.rsh:112:12:decimal', stdlib.UInt_max, 100000));
  ;
  const v594 = stdlib.sub(v590, stdlib.checkedBigNumberify('./index.rsh:113:12:decimal', stdlib.UInt_max, 100000));
  ;
  const v598 = stdlib.sub(v594, stdlib.checkedBigNumberify('./index.rsh:114:12:decimal', stdlib.UInt_max, 100000));
  ;
  const v599 = v565;
  const txn3 = await (ctc.recv({
    didSend: false,
    evt_cnt: 0,
    funcNum: 2,
    out_tys: [],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [], secs: v602, time: v601, didSend: v106, from: v600 } = txn3;
  ;
  ;
  const v606 = stdlib.addressEq(v599, v600);
  stdlib.assert(v606, {
    at: './index.rsh:120:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Constructor'
    });
  let v610 = stdlib.checkedBigNumberify('./index.rsh:155:24:decimal', stdlib.UInt_max, 0);
  let v611 = v577;
  let v612 = v565;
  let v613 = true;
  let v614 = v601;
  let v617 = v602;
  let v620 = v598;
  let v621 = stdlib.checkedBigNumberify('./index.rsh:120:12:decimal', stdlib.UInt_max, 1);
  
  while (await (async () => {
    
    return v613;})()) {
    const v636 = stdlib.add(v610, v570);
    const v637 = stdlib.div(v610, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
    const v638 = stdlib.mul(v637, v571);
    const v639 = stdlib.add(v610, v638);
    const v640 = stdlib.gt(v636, v639);
    const v641 = v640 ? v636 : v639;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc7],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v699], secs: v701, time: v700, didSend: v385, from: v698 } = txn4;
    switch (v699[0]) {
      case 'Bid_close0_151': {
        const v702 = v699[1];
        ;
        undefined;
        const v718 = null;
        await txn4.getOutput('Bid_close', 'v718', ctc2, v718);
        const v725 = stdlib.lt(v617, v611);
        const cv610 = v610;
        const cv611 = v611;
        const cv612 = v612;
        const cv613 = v725;
        const cv614 = v700;
        const cv617 = v701;
        const cv620 = v620;
        const cv621 = v621;
        
        v610 = cv610;
        v611 = cv611;
        v612 = cv612;
        v613 = cv613;
        v614 = cv614;
        v617 = cv617;
        v620 = cv620;
        v621 = cv621;
        
        continue;
        break;
        }
      case 'Bid_getBid0_151': {
        const v781 = v699[1];
        const v788 = v781[stdlib.checkedBigNumberify('./index.rsh:186:11:spread', stdlib.UInt_max, 0)];
        const v794 = stdlib.add(v620, v788);
        ;
        undefined;
        const v809 = stdlib.lt(v617, v611);
        const v816 = stdlib.ge(v788, v641);
        const v817 = v809 ? v816 : false;
        const v818 = stdlib.ge(v788, v569);
        const v819 = v817 ? v818 : false;
        stdlib.assert(v819, {
          at: './index.rsh:193:18:application',
          fs: ['at ./index.rsh:192:9:application call to [unknown function] (defined at: ./index.rsh:192:9:function exp)'],
          msg: null,
          who: 'Constructor'
          });
        const v823 = stdlib.sub(v794, v610);
        ;
        const v824 = null;
        await txn4.getOutput('Bid_getBid', 'v824', ctc2, v824);
        const v830 = stdlib.add(v611, stdlib.checkedBigNumberify('./index.rsh:143:33:decimal', stdlib.UInt_max, 60));
        const cv610 = v788;
        const cv611 = v830;
        const cv612 = v698;
        const cv613 = true;
        const cv614 = v700;
        const cv617 = v701;
        const cv620 = v823;
        const cv621 = v621;
        
        v610 = cv610;
        v611 = cv611;
        v612 = cv612;
        v613 = cv613;
        v614 = cv614;
        v617 = cv617;
        v620 = cv620;
        v621 = cv621;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0_151': {
        const v860 = v699[1];
        const v869 = v860[stdlib.checkedBigNumberify('./index.rsh:211:11:spread', stdlib.UInt_max, 0)];
        const v873 = stdlib.add(v620, v869);
        ;
        undefined;
        const v914 = stdlib.ge(v617, v611);
        const v915 = stdlib.lt(v610, v568);
        const v916 = v914 ? v915 : false;
        const v917 = stdlib.ge(v869, v568);
        const v918 = v916 ? v917 : false;
        stdlib.assert(v918, {
          at: './index.rsh:219:18:application',
          fs: ['at ./index.rsh:218:9:application call to [unknown function] (defined at: ./index.rsh:218:9:function exp)'],
          msg: null,
          who: 'Constructor'
          });
        const v922 = stdlib.sub(v873, v610);
        ;
        const v923 = null;
        await txn4.getOutput('Bid_getPurchase', 'v923', ctc2, v923);
        const cv610 = v869;
        const cv611 = v611;
        const cv612 = v698;
        const cv613 = false;
        const cv614 = v700;
        const cv617 = v701;
        const cv620 = v922;
        const cv621 = v621;
        
        v610 = cv610;
        v611 = cv611;
        v612 = cv612;
        v613 = cv613;
        v614 = cv614;
        v617 = cv617;
        v620 = cv620;
        v621 = cv621;
        
        continue;
        break;
        }
      case 'Bid_touch0_151': {
        const v939 = v699[1];
        ;
        undefined;
        const v1011 = null;
        await txn4.getOutput('Bid_touch', 'v1011', ctc2, v1011);
        const cv610 = v610;
        const cv611 = v611;
        const cv612 = v612;
        const cv613 = true;
        const cv614 = v700;
        const cv617 = v701;
        const cv620 = v620;
        const cv621 = v621;
        
        v610 = cv610;
        v611 = cv611;
        v612 = cv612;
        v613 = cv613;
        v614 = cv614;
        v617 = cv617;
        v620 = cv620;
        v621 = cv621;
        
        continue;
        break;
        }
      }
    
    }
  const v1018 = stdlib.add(v610, v570);
  const v1019 = stdlib.div(v610, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
  const v1020 = stdlib.mul(v1019, v571);
  const v1021 = stdlib.add(v610, v1020);
  const v1022 = stdlib.gt(v1018, v1021);
  const v1023 = v1022 ? v1018 : v1021;
  const v1025 = stdlib.div(v620, stdlib.checkedBigNumberify('./index.rsh:257:28:decimal', stdlib.UInt_max, 100));
  const v1026 = stdlib.mul(v567, v1025);
  const v1028 = stdlib.add(v1026, v1025);
  const v1029 = stdlib.sub(v620, v1028);
  const v1030 = stdlib.ge(v610, v568);
  if (v1030) {
    ;
    ;
    ;
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 4,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1051, time: v1050, didSend: v511, from: v1049 } = txn4;
    ;
    const v1053 = stdlib.addressEq(v541, v1049);
    stdlib.assert(v1053, {
      at: './index.rsh:295:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Constructor'
      });
    return;
    
    
    }
  else {
    const v1058 = stdlib.add(v1029, v1026);
    const v1059 = stdlib.add(v1058, v1025);
    ;
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 5,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1072, time: v1071, didSend: v511, from: v1070 } = txn4;
    ;
    const v1074 = stdlib.addressEq(v541, v1070);
    stdlib.assert(v1074, {
      at: './index.rsh:295:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Constructor'
      });
    return;
    
    
    }
  
  
  
  
  
  };
export async function Depositer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Depositer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Depositer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_close0_151: ctc4,
    Bid_getBid0_151: ctc5,
    Bid_getPurchase0_151: ctc5,
    Bid_touch0_151: ctc4
    });
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 4,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v534, v535, v536, v537], secs: v539, time: v538, didSend: v36, from: v533 } = txn1;
  ;
  const v541 = v537;
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 12,
    funcNum: 1,
    out_tys: [ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc1],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v566, v567, v568, v569, v570, v571, v572, v573, v574, v575, v576, v577], secs: v579, time: v578, didSend: v80, from: v565 } = txn2;
  ;
  ;
  const v582 = stdlib.ge(v567, stdlib.checkedBigNumberify('./index.rsh:108:27:decimal', stdlib.UInt_max, 0));
  const v583 = stdlib.le(v567, stdlib.checkedBigNumberify('./index.rsh:108:48:decimal', stdlib.UInt_max, 99));
  const v584 = v582 ? v583 : false;
  stdlib.assert(v584, {
    at: './index.rsh:108:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v585 = stdlib.ge(v569, stdlib.checkedBigNumberify('./index.rsh:109:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v585, {
    at: './index.rsh:109:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v586 = stdlib.lt(v569, v568);
  stdlib.assert(v586, {
    at: './index.rsh:110:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v590 = stdlib.sub(stdlib.checkedBigNumberify('./index.rsh:107:11:decimal', stdlib.UInt_max, 300000), stdlib.checkedBigNumberify('./index.rsh:112:12:decimal', stdlib.UInt_max, 100000));
  ;
  const v594 = stdlib.sub(v590, stdlib.checkedBigNumberify('./index.rsh:113:12:decimal', stdlib.UInt_max, 100000));
  ;
  const v598 = stdlib.sub(v594, stdlib.checkedBigNumberify('./index.rsh:114:12:decimal', stdlib.UInt_max, 100000));
  ;
  const v599 = ctc.iam(v565);
  const txn3 = await (ctc.sendrecv({
    args: [v535, v541, v565, v566, v567, v568, v569, v570, v571, v574, v577, v598, v599],
    evt_cnt: 0,
    funcNum: 2,
    lct: v578,
    onlyIf: true,
    out_tys: [],
    pay: [stdlib.checkedBigNumberify('./index.rsh:120:6:dot', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./index.rsh:120:12:decimal', stdlib.UInt_max, 1), v574]]],
    sim_p: (async (txn3) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [], secs: v602, time: v601, didSend: v106, from: v600 } = txn3;
      
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./index.rsh:120:6:dot', stdlib.UInt_max, 0),
        kind: 'to',
        tok: undefined
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./index.rsh:120:12:decimal', stdlib.UInt_max, 1),
        kind: 'to',
        tok: v574
        });
      const v606 = stdlib.addressEq(v599, v600);
      stdlib.assert(v606, {
        at: './index.rsh:120:6:dot',
        fs: [],
        msg: 'sender correct',
        who: 'Depositer'
        });
      
      const v610 = stdlib.checkedBigNumberify('./index.rsh:155:24:decimal', stdlib.UInt_max, 0);
      const v611 = v577;
      const v612 = v565;
      const v613 = true;
      const v614 = v601;
      const v617 = v602;
      const v620 = v598;
      const v621 = stdlib.checkedBigNumberify('./index.rsh:120:12:decimal', stdlib.UInt_max, 1);
      
      if (await (async () => {
        
        return v613;})()) {
        const v636 = stdlib.add(v610, v570);
        const v637 = stdlib.div(v610, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
        const v638 = stdlib.mul(v637, v571);
        const v639 = stdlib.add(v610, v638);
        const v640 = stdlib.gt(v636, v639);
        const v641 = v640 ? v636 : v639;
        sim_r.isHalt = false;
        }
      else {
        const v1018 = stdlib.add(v610, v570);
        const v1019 = stdlib.div(v610, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
        const v1020 = stdlib.mul(v1019, v571);
        const v1021 = stdlib.add(v610, v1020);
        const v1022 = stdlib.gt(v1018, v1021);
        const v1023 = v1022 ? v1018 : v1021;
        const v1025 = stdlib.div(v620, stdlib.checkedBigNumberify('./index.rsh:257:28:decimal', stdlib.UInt_max, 100));
        const v1026 = stdlib.mul(v567, v1025);
        const v1028 = stdlib.add(v1026, v1025);
        const v1029 = stdlib.sub(v620, v1028);
        const v1030 = stdlib.ge(v610, v568);
        if (v1030) {
          sim_r.txns.push({
            amt: v621,
            kind: 'from',
            to: v612,
            tok: v574
            });
          sim_r.txns.push({
            amt: v1026,
            kind: 'from',
            to: v566,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1025,
            kind: 'from',
            to: v535,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1029,
            kind: 'from',
            to: v565,
            tok: undefined
            });
          sim_r.isHalt = false;
          }
        else {
          const v1058 = stdlib.add(v1029, v1026);
          const v1059 = stdlib.add(v1058, v1025);
          sim_r.txns.push({
            amt: v1059,
            kind: 'from',
            to: v612,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v621,
            kind: 'from',
            to: v565,
            tok: v574
            });
          sim_r.isHalt = false;
          }}
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc0],
    waitIfNotPresent: false
    }));
  const {data: [], secs: v602, time: v601, didSend: v106, from: v600 } = txn3;
  ;
  ;
  const v606 = stdlib.addressEq(v599, v600);
  stdlib.assert(v606, {
    at: './index.rsh:120:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Depositer'
    });
  stdlib.protect(ctc3, await interact.signal(), {
    at: './index.rsh:122:39:application',
    fs: ['at ./index.rsh:122:17:application call to [unknown function] (defined at: ./index.rsh:122:21:function exp)'],
    msg: 'signal',
    who: 'Depositer'
    });
  
  let v610 = stdlib.checkedBigNumberify('./index.rsh:155:24:decimal', stdlib.UInt_max, 0);
  let v611 = v577;
  let v612 = v565;
  let v613 = true;
  let v614 = v601;
  let v617 = v602;
  let v620 = v598;
  let v621 = stdlib.checkedBigNumberify('./index.rsh:120:12:decimal', stdlib.UInt_max, 1);
  
  while (await (async () => {
    
    return v613;})()) {
    const v636 = stdlib.add(v610, v570);
    const v637 = stdlib.div(v610, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
    const v638 = stdlib.mul(v637, v571);
    const v639 = stdlib.add(v610, v638);
    const v640 = stdlib.gt(v636, v639);
    const v641 = v640 ? v636 : v639;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc6],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v699], secs: v701, time: v700, didSend: v385, from: v698 } = txn4;
    switch (v699[0]) {
      case 'Bid_close0_151': {
        const v702 = v699[1];
        ;
        undefined;
        const v718 = null;
        await txn4.getOutput('Bid_close', 'v718', ctc3, v718);
        const v725 = stdlib.lt(v617, v611);
        const cv610 = v610;
        const cv611 = v611;
        const cv612 = v612;
        const cv613 = v725;
        const cv614 = v700;
        const cv617 = v701;
        const cv620 = v620;
        const cv621 = v621;
        
        v610 = cv610;
        v611 = cv611;
        v612 = cv612;
        v613 = cv613;
        v614 = cv614;
        v617 = cv617;
        v620 = cv620;
        v621 = cv621;
        
        continue;
        break;
        }
      case 'Bid_getBid0_151': {
        const v781 = v699[1];
        const v788 = v781[stdlib.checkedBigNumberify('./index.rsh:186:11:spread', stdlib.UInt_max, 0)];
        const v794 = stdlib.add(v620, v788);
        ;
        undefined;
        const v809 = stdlib.lt(v617, v611);
        const v816 = stdlib.ge(v788, v641);
        const v817 = v809 ? v816 : false;
        const v818 = stdlib.ge(v788, v569);
        const v819 = v817 ? v818 : false;
        stdlib.assert(v819, {
          at: './index.rsh:193:18:application',
          fs: ['at ./index.rsh:192:9:application call to [unknown function] (defined at: ./index.rsh:192:9:function exp)'],
          msg: null,
          who: 'Depositer'
          });
        const v823 = stdlib.sub(v794, v610);
        ;
        const v824 = null;
        await txn4.getOutput('Bid_getBid', 'v824', ctc3, v824);
        const v830 = stdlib.add(v611, stdlib.checkedBigNumberify('./index.rsh:143:33:decimal', stdlib.UInt_max, 60));
        const cv610 = v788;
        const cv611 = v830;
        const cv612 = v698;
        const cv613 = true;
        const cv614 = v700;
        const cv617 = v701;
        const cv620 = v823;
        const cv621 = v621;
        
        v610 = cv610;
        v611 = cv611;
        v612 = cv612;
        v613 = cv613;
        v614 = cv614;
        v617 = cv617;
        v620 = cv620;
        v621 = cv621;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0_151': {
        const v860 = v699[1];
        const v869 = v860[stdlib.checkedBigNumberify('./index.rsh:211:11:spread', stdlib.UInt_max, 0)];
        const v873 = stdlib.add(v620, v869);
        ;
        undefined;
        const v914 = stdlib.ge(v617, v611);
        const v915 = stdlib.lt(v610, v568);
        const v916 = v914 ? v915 : false;
        const v917 = stdlib.ge(v869, v568);
        const v918 = v916 ? v917 : false;
        stdlib.assert(v918, {
          at: './index.rsh:219:18:application',
          fs: ['at ./index.rsh:218:9:application call to [unknown function] (defined at: ./index.rsh:218:9:function exp)'],
          msg: null,
          who: 'Depositer'
          });
        const v922 = stdlib.sub(v873, v610);
        ;
        const v923 = null;
        await txn4.getOutput('Bid_getPurchase', 'v923', ctc3, v923);
        const cv610 = v869;
        const cv611 = v611;
        const cv612 = v698;
        const cv613 = false;
        const cv614 = v700;
        const cv617 = v701;
        const cv620 = v922;
        const cv621 = v621;
        
        v610 = cv610;
        v611 = cv611;
        v612 = cv612;
        v613 = cv613;
        v614 = cv614;
        v617 = cv617;
        v620 = cv620;
        v621 = cv621;
        
        continue;
        break;
        }
      case 'Bid_touch0_151': {
        const v939 = v699[1];
        ;
        undefined;
        const v1011 = null;
        await txn4.getOutput('Bid_touch', 'v1011', ctc3, v1011);
        const cv610 = v610;
        const cv611 = v611;
        const cv612 = v612;
        const cv613 = true;
        const cv614 = v700;
        const cv617 = v701;
        const cv620 = v620;
        const cv621 = v621;
        
        v610 = cv610;
        v611 = cv611;
        v612 = cv612;
        v613 = cv613;
        v614 = cv614;
        v617 = cv617;
        v620 = cv620;
        v621 = cv621;
        
        continue;
        break;
        }
      }
    
    }
  const v1018 = stdlib.add(v610, v570);
  const v1019 = stdlib.div(v610, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
  const v1020 = stdlib.mul(v1019, v571);
  const v1021 = stdlib.add(v610, v1020);
  const v1022 = stdlib.gt(v1018, v1021);
  const v1023 = v1022 ? v1018 : v1021;
  const v1025 = stdlib.div(v620, stdlib.checkedBigNumberify('./index.rsh:257:28:decimal', stdlib.UInt_max, 100));
  const v1026 = stdlib.mul(v567, v1025);
  const v1028 = stdlib.add(v1026, v1025);
  const v1029 = stdlib.sub(v620, v1028);
  const v1030 = stdlib.ge(v610, v568);
  if (v1030) {
    ;
    ;
    ;
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 4,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1051, time: v1050, didSend: v511, from: v1049 } = txn4;
    ;
    const v1053 = stdlib.addressEq(v541, v1049);
    stdlib.assert(v1053, {
      at: './index.rsh:295:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Depositer'
      });
    return;
    
    
    }
  else {
    const v1058 = stdlib.add(v1029, v1026);
    const v1059 = stdlib.add(v1058, v1025);
    ;
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 5,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1072, time: v1071, didSend: v511, from: v1070 } = txn4;
    ;
    const v1074 = stdlib.addressEq(v541, v1070);
    stdlib.assert(v1074, {
      at: './index.rsh:295:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Depositer'
      });
    return;
    
    
    }
  
  
  
  
  
  };
export async function Relay(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Relay expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Relay expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_close0_151: ctc4,
    Bid_getBid0_151: ctc5,
    Bid_getPurchase0_151: ctc5,
    Bid_touch0_151: ctc4
    });
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 4,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v534, v535, v536, v537], secs: v539, time: v538, didSend: v36, from: v533 } = txn1;
  ;
  const v541 = ctc.iam(v537);
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 12,
    funcNum: 1,
    out_tys: [ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc1],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v566, v567, v568, v569, v570, v571, v572, v573, v574, v575, v576, v577], secs: v579, time: v578, didSend: v80, from: v565 } = txn2;
  ;
  ;
  const v582 = stdlib.ge(v567, stdlib.checkedBigNumberify('./index.rsh:108:27:decimal', stdlib.UInt_max, 0));
  const v583 = stdlib.le(v567, stdlib.checkedBigNumberify('./index.rsh:108:48:decimal', stdlib.UInt_max, 99));
  const v584 = v582 ? v583 : false;
  stdlib.assert(v584, {
    at: './index.rsh:108:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v585 = stdlib.ge(v569, stdlib.checkedBigNumberify('./index.rsh:109:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v585, {
    at: './index.rsh:109:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v586 = stdlib.lt(v569, v568);
  stdlib.assert(v586, {
    at: './index.rsh:110:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v590 = stdlib.sub(stdlib.checkedBigNumberify('./index.rsh:107:11:decimal', stdlib.UInt_max, 300000), stdlib.checkedBigNumberify('./index.rsh:112:12:decimal', stdlib.UInt_max, 100000));
  ;
  const v594 = stdlib.sub(v590, stdlib.checkedBigNumberify('./index.rsh:113:12:decimal', stdlib.UInt_max, 100000));
  ;
  const v598 = stdlib.sub(v594, stdlib.checkedBigNumberify('./index.rsh:114:12:decimal', stdlib.UInt_max, 100000));
  ;
  const v599 = v565;
  const txn3 = await (ctc.recv({
    didSend: false,
    evt_cnt: 0,
    funcNum: 2,
    out_tys: [],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [], secs: v602, time: v601, didSend: v106, from: v600 } = txn3;
  ;
  ;
  const v606 = stdlib.addressEq(v599, v600);
  stdlib.assert(v606, {
    at: './index.rsh:120:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Relay'
    });
  let v610 = stdlib.checkedBigNumberify('./index.rsh:155:24:decimal', stdlib.UInt_max, 0);
  let v611 = v577;
  let v612 = v565;
  let v613 = true;
  let v614 = v601;
  let v617 = v602;
  let v620 = v598;
  let v621 = stdlib.checkedBigNumberify('./index.rsh:120:12:decimal', stdlib.UInt_max, 1);
  
  while (await (async () => {
    
    return v613;})()) {
    const v636 = stdlib.add(v610, v570);
    const v637 = stdlib.div(v610, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
    const v638 = stdlib.mul(v637, v571);
    const v639 = stdlib.add(v610, v638);
    const v640 = stdlib.gt(v636, v639);
    const v641 = v640 ? v636 : v639;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc6],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v699], secs: v701, time: v700, didSend: v385, from: v698 } = txn4;
    switch (v699[0]) {
      case 'Bid_close0_151': {
        const v702 = v699[1];
        ;
        undefined;
        const v718 = null;
        await txn4.getOutput('Bid_close', 'v718', ctc3, v718);
        const v725 = stdlib.lt(v617, v611);
        const cv610 = v610;
        const cv611 = v611;
        const cv612 = v612;
        const cv613 = v725;
        const cv614 = v700;
        const cv617 = v701;
        const cv620 = v620;
        const cv621 = v621;
        
        v610 = cv610;
        v611 = cv611;
        v612 = cv612;
        v613 = cv613;
        v614 = cv614;
        v617 = cv617;
        v620 = cv620;
        v621 = cv621;
        
        continue;
        break;
        }
      case 'Bid_getBid0_151': {
        const v781 = v699[1];
        const v788 = v781[stdlib.checkedBigNumberify('./index.rsh:186:11:spread', stdlib.UInt_max, 0)];
        const v794 = stdlib.add(v620, v788);
        ;
        undefined;
        const v809 = stdlib.lt(v617, v611);
        const v816 = stdlib.ge(v788, v641);
        const v817 = v809 ? v816 : false;
        const v818 = stdlib.ge(v788, v569);
        const v819 = v817 ? v818 : false;
        stdlib.assert(v819, {
          at: './index.rsh:193:18:application',
          fs: ['at ./index.rsh:192:9:application call to [unknown function] (defined at: ./index.rsh:192:9:function exp)'],
          msg: null,
          who: 'Relay'
          });
        const v823 = stdlib.sub(v794, v610);
        ;
        const v824 = null;
        await txn4.getOutput('Bid_getBid', 'v824', ctc3, v824);
        const v830 = stdlib.add(v611, stdlib.checkedBigNumberify('./index.rsh:143:33:decimal', stdlib.UInt_max, 60));
        const cv610 = v788;
        const cv611 = v830;
        const cv612 = v698;
        const cv613 = true;
        const cv614 = v700;
        const cv617 = v701;
        const cv620 = v823;
        const cv621 = v621;
        
        v610 = cv610;
        v611 = cv611;
        v612 = cv612;
        v613 = cv613;
        v614 = cv614;
        v617 = cv617;
        v620 = cv620;
        v621 = cv621;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0_151': {
        const v860 = v699[1];
        const v869 = v860[stdlib.checkedBigNumberify('./index.rsh:211:11:spread', stdlib.UInt_max, 0)];
        const v873 = stdlib.add(v620, v869);
        ;
        undefined;
        const v914 = stdlib.ge(v617, v611);
        const v915 = stdlib.lt(v610, v568);
        const v916 = v914 ? v915 : false;
        const v917 = stdlib.ge(v869, v568);
        const v918 = v916 ? v917 : false;
        stdlib.assert(v918, {
          at: './index.rsh:219:18:application',
          fs: ['at ./index.rsh:218:9:application call to [unknown function] (defined at: ./index.rsh:218:9:function exp)'],
          msg: null,
          who: 'Relay'
          });
        const v922 = stdlib.sub(v873, v610);
        ;
        const v923 = null;
        await txn4.getOutput('Bid_getPurchase', 'v923', ctc3, v923);
        const cv610 = v869;
        const cv611 = v611;
        const cv612 = v698;
        const cv613 = false;
        const cv614 = v700;
        const cv617 = v701;
        const cv620 = v922;
        const cv621 = v621;
        
        v610 = cv610;
        v611 = cv611;
        v612 = cv612;
        v613 = cv613;
        v614 = cv614;
        v617 = cv617;
        v620 = cv620;
        v621 = cv621;
        
        continue;
        break;
        }
      case 'Bid_touch0_151': {
        const v939 = v699[1];
        ;
        undefined;
        const v1011 = null;
        await txn4.getOutput('Bid_touch', 'v1011', ctc3, v1011);
        const cv610 = v610;
        const cv611 = v611;
        const cv612 = v612;
        const cv613 = true;
        const cv614 = v700;
        const cv617 = v701;
        const cv620 = v620;
        const cv621 = v621;
        
        v610 = cv610;
        v611 = cv611;
        v612 = cv612;
        v613 = cv613;
        v614 = cv614;
        v617 = cv617;
        v620 = cv620;
        v621 = cv621;
        
        continue;
        break;
        }
      }
    
    }
  const v1018 = stdlib.add(v610, v570);
  const v1019 = stdlib.div(v610, stdlib.checkedBigNumberify('./util.rsh:71:37:decimal', stdlib.UInt_max, 100));
  const v1020 = stdlib.mul(v1019, v571);
  const v1021 = stdlib.add(v610, v1020);
  const v1022 = stdlib.gt(v1018, v1021);
  const v1023 = v1022 ? v1018 : v1021;
  const v1025 = stdlib.div(v620, stdlib.checkedBigNumberify('./index.rsh:257:28:decimal', stdlib.UInt_max, 100));
  const v1026 = stdlib.mul(v567, v1025);
  const v1028 = stdlib.add(v1026, v1025);
  const v1029 = stdlib.sub(v620, v1028);
  const v1030 = stdlib.ge(v610, v568);
  if (v1030) {
    ;
    ;
    ;
    ;
    const txn4 = await (ctc.sendrecv({
      args: [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023],
      evt_cnt: 0,
      funcNum: 4,
      lct: v614,
      onlyIf: true,
      out_tys: [],
      pay: [stdlib.checkedBigNumberify('./index.rsh:295:7:decimal', stdlib.UInt_max, 0), []],
      sim_p: (async (txn4) => {
        const sim_r = { txns: [], mapRefs: [], maps: [] };
        
        const {data: [], secs: v1051, time: v1050, didSend: v511, from: v1049 } = txn4;
        
        sim_r.txns.push({
          amt: stdlib.checkedBigNumberify('./index.rsh:295:7:decimal', stdlib.UInt_max, 0),
          kind: 'to',
          tok: undefined
          });
        const v1053 = stdlib.addressEq(v541, v1049);
        stdlib.assert(v1053, {
          at: './index.rsh:295:7:dot',
          fs: [],
          msg: 'sender correct',
          who: 'Relay'
          });
        sim_r.txns.push({
          kind: 'halt',
          tok: v574
          })
        sim_r.txns.push({
          kind: 'halt',
          tok: undefined
          })
        sim_r.isHalt = true;
        
        return sim_r;
        }),
      soloSend: true,
      timeoutAt: undefined,
      tys: [ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc0, ctc1],
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1051, time: v1050, didSend: v511, from: v1049 } = txn4;
    ;
    const v1053 = stdlib.addressEq(v541, v1049);
    stdlib.assert(v1053, {
      at: './index.rsh:295:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Relay'
      });
    return;
    
    
    }
  else {
    const v1058 = stdlib.add(v1029, v1026);
    const v1059 = stdlib.add(v1058, v1025);
    ;
    ;
    const txn4 = await (ctc.sendrecv({
      args: [v541, v565, v567, v568, v569, v574, v610, v611, v612, v1023],
      evt_cnt: 0,
      funcNum: 5,
      lct: v614,
      onlyIf: true,
      out_tys: [],
      pay: [stdlib.checkedBigNumberify('./index.rsh:295:7:decimal', stdlib.UInt_max, 0), []],
      sim_p: (async (txn4) => {
        const sim_r = { txns: [], mapRefs: [], maps: [] };
        
        const {data: [], secs: v1072, time: v1071, didSend: v511, from: v1070 } = txn4;
        
        sim_r.txns.push({
          amt: stdlib.checkedBigNumberify('./index.rsh:295:7:decimal', stdlib.UInt_max, 0),
          kind: 'to',
          tok: undefined
          });
        const v1074 = stdlib.addressEq(v541, v1070);
        stdlib.assert(v1074, {
          at: './index.rsh:295:7:dot',
          fs: [],
          msg: 'sender correct',
          who: 'Relay'
          });
        sim_r.txns.push({
          kind: 'halt',
          tok: v574
          })
        sim_r.txns.push({
          kind: 'halt',
          tok: undefined
          })
        sim_r.isHalt = true;
        
        return sim_r;
        }),
      soloSend: true,
      timeoutAt: undefined,
      tys: [ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc1, ctc1, ctc0, ctc1],
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1072, time: v1071, didSend: v511, from: v1070 } = txn4;
    ;
    const v1074 = stdlib.addressEq(v541, v1070);
    stdlib.assert(v1074, {
      at: './index.rsh:295:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Relay'
      });
    return;
    
    
    }
  
  
  
  
  
  };
const _ALGO = {
  appApproval: `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`,
  appClear: `BYEA`,
  extraPages: 1,
  mapDataKeys: 0,
  mapDataSize: 0,
  stateKeys: 3,
  stateSize: 256,
  unsupported: [],
  version: 8
  };
const _ETH = {
  ABI: `[
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v534",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v535",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v536",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v537",
                "type": "address"
              }
            ],
            "internalType": "struct T4",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T5",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "stateMutability": "payable",
    "type": "constructor"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "msg",
        "type": "uint256"
      }
    ],
    "name": "ReachError",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v534",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v535",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v536",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v537",
                "type": "address"
              }
            ],
            "internalType": "struct T4",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T5",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e0",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v566",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v567",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v568",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v569",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v570",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v571",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v572",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v573",
                "type": "uint256"
              },
              {
                "internalType": "address payable",
                "name": "v574",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v575",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v576",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v577",
                "type": "uint256"
              }
            ],
            "internalType": "struct T6",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T7",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e1",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T12",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e2",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T12",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e4",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T12",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e5",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T15",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T13",
                    "name": "_Bid_close0_151",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_getBid0_151",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_getPurchase0_151",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T13",
                    "name": "_Bid_touch0_151",
                    "type": "tuple"
                  }
                ],
                "internalType": "struct T15",
                "name": "v699",
                "type": "tuple"
              }
            ],
            "internalType": "struct T16",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T17",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e6",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1011",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v718",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v824",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v923",
    "type": "event"
  },
  {
    "stateMutability": "payable",
    "type": "fallback"
  },
  {
    "inputs": [],
    "name": "Auction_bids",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_closed",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_closes",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_currentPrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_endCTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_endSecs",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_highestBidder",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_lastCTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_minBid",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_reservePrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_royalties",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_startPrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_token",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bool",
        "name": "_a0",
        "type": "bool"
      }
    ],
    "name": "Bid_close",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_a0",
        "type": "uint256"
      }
    ],
    "name": "Bid_getBid",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_a0",
        "type": "uint256"
      }
    ],
    "name": "Bid_getPurchase",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bool",
        "name": "_a0",
        "type": "bool"
      }
    ],
    "name": "Bid_touch",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCreationTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCurrentState",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCurrentTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v566",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v567",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v568",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v569",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v570",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v571",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v572",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v573",
                "type": "uint256"
              },
              {
                "internalType": "address payable",
                "name": "v574",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v575",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v576",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v577",
                "type": "uint256"
              }
            ],
            "internalType": "struct T6",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T7",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m1",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T12",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m2",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T12",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m4",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T12",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m5",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T15",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T13",
                    "name": "_Bid_close0_151",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_getBid0_151",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_getPurchase0_151",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T13",
                    "name": "_Bid_touch0_151",
                    "type": "tuple"
                  }
                ],
                "internalType": "struct T15",
                "name": "v699",
                "type": "tuple"
              }
            ],
            "internalType": "struct T16",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T17",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m6",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "stateMutability": "payable",
    "type": "receive"
  }
]`,
  Bytecode: `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`,
  BytecodeLen: 24514,
  Which: `oD`,
  version: 6,
  views: {
    Auction: {
      bids: `Auction_bids`,
      closed: `Auction_closed`,
      closes: `Auction_closes`,
      currentPrice: `Auction_currentPrice`,
      endCTime: `Auction_endCTime`,
      endSecs: `Auction_endSecs`,
      highestBidder: `Auction_highestBidder`,
      lastCTime: `Auction_lastCTime`,
      minBid: `Auction_minBid`,
      owner: `Auction_owner`,
      reservePrice: `Auction_reservePrice`,
      royalties: `Auction_royalties`,
      startPrice: `Auction_startPrice`,
      token: `Auction_token`
      }
    }
  };
export const _Connectors = {
  ALGO: _ALGO,
  ETH: _ETH
  };
export const _Participants = {
  "Auctioneer": Auctioneer,
  "Bid_close": Bid_close,
  "Bid_getBid": Bid_getBid,
  "Bid_getPurchase": Bid_getPurchase,
  "Bid_touch": Bid_touch,
  "Constructor": Constructor,
  "Depositer": Depositer,
  "Relay": Relay
  };
export const _APIs = {
  Bid: {
    close: Bid_close,
    getBid: Bid_getBid,
    getPurchase: Bid_getPurchase,
    touch: Bid_touch
    }
  };
